module.exports = __webpack_public_path__ + "assets/img/42.22f177d0.png";